import { client } from "utils/api";

const getPrototypeOptions = (q) =>
  new Promise(async (resolve, reject) => {
    try {
      const { data } = await client.get(
        `/prototypes?context=list&per_page=50${
          q ? `&q[name_matches]=%25${q}%25` : ""
        }`
      );

      const options = data.map(({ id, name }) => ({
        label: name,
        value: id,
      }));

      resolve(options);
    } catch (error) {
      console.log(error);
      reject([]);
    }
  });

export default getPrototypeOptions;
